const ITEMS = ["Parfums d'Exception", "Maison Élixir", "Disfruta tu esencia", "Entrega a domicilio", "Pago contra reembolso"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/10 bg-black py-6 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((text, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif-lux text-xl sm:text-2xl tracking-[0.3em] uppercase text-neutral-500 px-8">{text}</span>
                <span className="text-gold text-xs">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
